import {useState, useEffect, useContext} from 'react';

import Search from '../../../base_components/Search';
import Select from '../../../base_components/select/Select';
import UserCard from '../../../base_components/UserCard';
import Context from '../Context';
import {isEmptyObject} from '../../../utils/utils';

import styles from '../../../styles/users/UsersList.module.scss';

function UsersList(props) {
  const [input, setInput] = useState('');
  const [groups, setGroups] = useState({});
  const [placeholder, setPlaceholder] = useState('');

  const [sFilteredUsers, setSFilteredUsers] = useState({});
  const [gFilteredUsers, setGFilteredUsers] = useState({});
  const [filteredUsers, setFilteredUsers] = useState({});

  const context = useContext(Context);

  useEffect(() => {  // filter by search input
    if (input.trim() === '') {
      setSFilteredUsers(context.users);
      return;
    }

    const timer = setTimeout(() =>
        setSFilteredUsers(() => {
          let newSFilteredUsers = {};
          for (let id in context.users) {
            if (
              context.users[id].username.toLowerCase().includes(input.toLowerCase()) ||
              context.users[id].email.toLowerCase().includes(input.toLowerCase())
            ) newSFilteredUsers[id] = context.users[id];
          }
          return newSFilteredUsers;
        }),
      500
    );
    return () => clearTimeout(timer);
  }, [input, context.users]);

  useEffect(() => {  // filter by groups
    const g = Object.keys(groups).filter(group => groups[group]);
    if (g.length === 0) {
      setGFilteredUsers(context.users);
      return;
    }

    setGFilteredUsers(() => {
      let newGFilteredUsers = {};
      for (let id in context.users) {
        for (let group of g) {
          if (context.users[id].groups.includes(group)) {
            newGFilteredUsers[id] = context.users[id];
          }
        }
      }
      return newGFilteredUsers;
    });
  }, [groups, context.users]);

  useEffect(() => {
    setFilteredUsers(() => {
      if (Object.keys(sFilteredUsers).length === 0 || Object.keys(gFilteredUsers).length === 0) return {};

      let newFilteredMicroservices = {};
      for (let id in sFilteredUsers) {
        if (Object.keys(gFilteredUsers).find(i => i === id)) {
          newFilteredMicroservices[id] = sFilteredUsers[id];
        }
      }
      return newFilteredMicroservices;
    });
  }, [sFilteredUsers, gFilteredUsers]);

  useEffect(() => {
    let g = {};
    for (let groupName of context.groups) {
      g[groupName] = (groupName === context.defaultGroup);
    }
    setGroups(g);
    setPlaceholder(context.defaultGroup);
  }, [context.groups, context.defaultGroup]);

  // TODO for empty object
  return isEmptyObject(context.users) ? (
    <></>
  ) : (
    <div className={styles.usersList + ' ' + props.className}>
      <h2>Users</h2>
      <Search
        className={styles.search}
        placeholder='Search by username, email'
        input={input}
        setInput={setInput}
      />
      <Select
        className={styles.select}
        placeholder={placeholder || 'Filter by group'}
        setPlaceholder={setPlaceholder}
        items={groups}
        setItems={setGroups}
      />

      <div className={styles.list}>
        {Object.keys(filteredUsers).map(id => (
          <UserCard key={id} id={id} context={Context}/>
        ))}
      </div>
    </div>
  );
}

export default UsersList;